<template>
    <div class="button-bar">
        <img class="button" src="../../assets/afile/prev_button.svg" alt="" @click="prevImage" draggable="false">
        <div v-for="(item, index) in images" :key=index class="option-button button"
            :class="{ 'now-image': index == nowIndex }" @click="changeImage(index)">{{ item }}</div>
        <img class="button" src="../../assets/afile/next_button.svg" alt="" @click="nextImage" draggable="false">
    </div>
</template>

<script>
export default {
    name: "ChangeImageBar",
    data: function () {
        return {
            nowImage: 0,
            maxDisplayCount: 6
        }
    },
    props: [
        "images",
        "nowIndex"
    ],
    methods: {
        nextImage: function () {
            this.$emit("nextImage");
        },
        prevImage: function () {
            this.$emit("prevImage");
        },
        changeImage: function (index) {
            this.$emit("changeImage", index);
        }
    },
    computed: {
        displayImages: function () {
            var tempImages = [];
            var i = 0;
            for (i = 0; i < this.maxDisplayCount; i++) {
                tempImages.push(this.images[i]);
            }
            return tempImages;
        }
    }
}
</script>

<style scoped>
.button-bar {
    position: absolute;
    width: fit-content;
    bottom: 0px;
    right: 0px;
    left: 0px;
    margin: auto;
    display: inline-flex;
    justify-content: center;
}

.button {
    margin: 0 0.1rem 0 0.1rem;
    /* width: calc(46px / var(--window-devicePixelRatio));
    height: calc(46px / var(--window-devicePixelRatio)); */
    width: 46px;
    height: 46px;
    user-select: none;
}

.option-button {
    background: url("../../assets/afile/option_button.svg");
    background-size: contain;
    background-repeat: no-repeat;
    color: white;
    text-align: center;
    line-height: 46px;
    /* font-size: calc(1.6rem / var(--window-devicePixelRatio)); */
    font-size: 1.6rem;
    font-weight: bold;
    font-family: Arial, Helvetica, sans-serif;
}

.option-button.now-image {
    background: url("../../assets/afile/option_button_selected.svg");
    background-size: contain;
    background-repeat: no-repeat;

}
</style>